// Content for the 5-Day Glow Up Challenge.
// Answers are never sent to the server; this content is presentational only.

export const DAYS = [
  {
    day: 1,
    theme: "Clarity",
    headline: "What Do You Actually Want?",
    body: [
      "Most women spend their days doing everything for everyone — and never stop to ask what THEY actually want. Not what looks good. Not what makes sense. What do YOU want for your life?",
      "Clarity isn't a luxury. It's the foundation of every glow up. Without it you'll keep starting over — busy but never really moving.",
      "Today we start there.",
    ],
    prompt:
      "If nothing in your life was off limits — no fear, no judgment, no limitations — what would your life look like one year from today? Be specific. Be honest. Be bold.",
    inputLabel: "Your answer (this is just for you):",
    placeholder: "Write whatever comes up. There are no wrong answers here.",
    buttonLabel: "Submit + Unlock Day 2",
    fineprint:
      "Your response is private. Completing this check-in unlocks Day 2 instantly.",
  },
  {
    day: 2,
    theme: "Habits",
    headline: "The 3 Habits That Change Everything",
    body: [
      "Your glow up isn't going to happen in one big moment. It's going to happen in the small things you do every single day — the ones nobody sees but you feel.",
      "James Clear said it best: you don't rise to the level of your goals. You fall to the level of your systems. Your habits ARE your glow up.",
      "The good news? You don't need to overhaul your entire life. You need three anchors. Three non-negotiables that tell your brain — I am becoming HER. Every. Single. Day.",
    ],
    prompt:
      "What are three daily habits that — if you did them consistently for 90 days — would make you unrecognizable? Write them down. Then ask yourself honestly: which one have you been avoiding?",
    inputLabel: "Your 3 habits + the one you've been avoiding:",
    placeholder: "Be specific. Small beats perfect.",
    buttonLabel: "Submit + Unlock Day 3",
    fineprint: "Your response is private. It unlocks Day 3 instantly.",
  },
  {
    day: 3,
    theme: "Mindset",
    headline: "The Lie You've Been Believing About Yourself",
    body: [
      "There is a story you've been telling yourself. About what you're capable of. About whether you deserve the life you want. About what happens when women like you dream too big.",
      "That story is a lie. And it's the only thing standing between you and your glow up.",
      "Mindset isn't about being positive. It's about being honest enough to catch yourself in the lie — and choose a different story on purpose.",
    ],
    prompt:
      "What is the #1 story you keep telling yourself about why you can't have what you want? Write it down. Then write the truth that replaces it. Not the hopeful version — the FACTUAL truth about who you are and what you're capable of.",
    inputLabel: "The lie + the truth that replaces it:",
    placeholder: "Tell yourself the truth. Gently. Firmly.",
    buttonLabel: "Submit + Unlock Day 4",
    fineprint: "Your response is private. It unlocks Day 4 instantly.",
  },
  {
    day: 4,
    theme: "Strategy",
    headline: "Stop Winging It.",
    body: [
      "Hope is not a strategy. Neither is working harder. Neither is waiting for the right moment.",
      "The women who are actually glowing up — in their businesses, their finances, their lives — they have a plan. Not a perfect plan. A REAL one. Built around where they are right now, where they want to go, and what they're willing to do to get there.",
      "Today you're going to build yours. Just the first version. Just enough to stop winging it and start moving with intention.",
    ],
    prompt:
      "Pick ONE goal from Day 1. Now answer: What is the #1 result you want in the next 90 days? What is the biggest obstacle in your way? What is ONE action you could take THIS WEEK that would move you forward? Write all three. That's your plan.",
    inputLabel: "Your goal, your obstacle, your first action:",
    placeholder: "Keep it real. Keep it simple.",
    buttonLabel: "Submit + Unlock Day 5",
    fineprint: "Your response is private. It unlocks Day 5 instantly.",
  },
  {
    day: 5,
    theme: "Well-being",
    headline: "You Can't Glow Up Running on Empty.",
    body: [
      "You made it to Day 5. And I need you to hear something before we close this out.",
      "Everything we talked about this week — the clarity, the habits, the mindset shifts, the strategy — none of it works if you are burned out, depleted, and running on fumes.",
      "Well-being is not the reward you get after you achieve your goals. It is the foundation that makes achieving them possible.",
      "The version of you that becomes HER? She rests. She sets boundaries. She fills her own cup. She takes care of the body and mind that carry her dreams.",
      "That's not soft. That's strategy.",
    ],
    prompt:
      "Where in your life are you most depleted right now? And what is ONE thing you could do this week — just one — to pour back into yourself?",
    inputLabel: "Where you're depleted + your one act of self-care:",
    placeholder: "Be gentle. Be specific.",
    buttonLabel: "Complete My Challenge",
    fineprint: "Your response is private. This completes your 5-day journey.",
  },
];
